const styles = (theme) => ({
  buttons: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    fontSize: theme.typography.pxToRem(13),
  },
});

export default styles;
